






























































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import i18n from '@/services/i18n';
import i18nDb from '@/services/i18n-db';
import { CollapsiblePane, ComponentBase, NumberInput, Overlay, Pagination } from '../components';
import type { Comp, Dict, Utils } from '../types';


type SortField = 'ID' | 'PARENT' | 'FORM' | 'NAME_KK' | 'NAME_RU' | 'ORDER_NUMBER' | 'HIDDABLE_CELL';

/**
 * Настройки поиска групп колонок отчетов штатного расписания
 */
interface DictStRepFormColGroupSearchConfig {
    /**
     * Количество элементов на странице
     */
    itemsPerPage: number | null;

    /**
     * Индекс страницы, нумерация с `0`
     */
    page: number | null;

    /**
     * Набор ID
     */
    idSet: Array<number> | null;

    /**
     * Набор ID родительских групп колонок
     */
    parentSet: Array<number | null> | null;

    /**
     * Набор кодов форм в формате "XX-XXX", где "X" - цифра
     */
    formSet: Array<string> | null;

    /**
     * Часть названия на казахском
     */
    nameKk: string | null;

    /**
     * Часть названия на русском
     */
    nameRu: string | null;

    /**
     * Стартовое значение диапазона: порядковый номер - для сортировки групп внутри одного родителя или групп верхнего уровня
     */
    orderNumberStartValue: number | null;

    /**
     * Конечное значение диапазона: порядковый номер - для сортировки групп внутри одного родителя или групп верхнего уровня
     */
    orderNumberEndValue: number | null;

    /**
     * Поле для сортировки
     */
    sortField: SortField | null;

    /**
     * Признак "обратная сортировка" (от большего к меньшему)
     */
    reversedSort: boolean | null;
}


const translates = {
    actions: {
        get add(): string {
            return i18n.choose(
                'Добавить',
                'Қосу',
                'Add',
            );
        },
        get apply(): string {
            return i18n.choose(
                'Применить',
                'Қолдану',
                'Apply',
            );
        },
        get delete(): string {
            return i18n.choose(
                'Удалить',
                'Жою',
                'Delete',
            );
        },
        get edit(): string {
            return i18n.choose(
                'Изменить',
                'Өзгерту',
                'Edit',
            );
        },
        get refresh(): string {
            return i18n.choose(
                'Обновить',
                'Жаңарту',
                'Refresh',
            );
        },
        get save(): string {
            return i18n.choose(
                'Сохранить',
                'Сақтау',
                'Save',
            );
        },
    },
    deletionConfirmationText(id: number): string {
        return i18n.choose(
            () => `Удалить элемент с ID #${id}?`,
            () => `#${id} идентификаторы бар элементті жою керек пе?`,
            () => `Delete element with ID #${id}?`,
        )();
    },
    errors: {
        get cannotDeleteData(): string {
            return i18n.choose(
                'Не удалось удалить данные',
                'Деректерді жою мүмкін болмады',
                'Failed to delete data',
            );
        },
        get cannotLoadData(): string {
            return i18n.choose(
                'Не удалось загрузить данные',
                'Деректерді жүктеу сәтсіз аяқталды',
                'Failed to load data',
            );
        },
        get cannotSaveData(): string {
            return i18n.choose(
                'Не удалось сохранить данные',
                'Деректерді сақтау мүмкін болмады',
                'Failed to save data',
            );
        },
    },
    fields: {
        id: {
            get title(): string {
                return 'ID';
            },
        },
        parent: {
            get title(): string {
                return i18n.choose(
                    'ID родительской группы колонок',
                    'Негізгі бағандар тобының ID',
                    'ID of the parent column group',
                );
            },
        },
        form: {
            get title(): string {
                return i18n.choose(
                    'Код формы в формате "XX-XXX", где "X" - цифра',
                    'Пішін коды "XX-XXX" пішіміндегі, мұндағы "X" - сан',
                    'Form code in the format "XX-XXX", where "X" is a digit',
                );
            },
        },
        nameKk: {
            get title(): string {
                return i18n.choose(
                    'Название на казахском',
                    'Аты қазақша',
                    'Name in kazakh',
                );
            },
        },
        nameRu: {
            get title(): string {
                return i18n.choose(
                    'Название на русском',
                    'Орысша атауы',
                    'Name in russian',
                );
            },
        },
        orderNumber: {
            get title(): string {
                return i18n.choose(
                    'Порядковый номер',
                    'Сериялық нөмірі',
                    'Order number',
                );
            },
        },
        hiddableCell: {
            get title(): string {
                return i18n.choose(
                    'Ячейка группы может быть скрыта при разных условиях',
                    'Топтық ұяшықты әртүрлі жағдайларда жасыруға болады',
                    'A group cell can be hidden under different conditions',
                );
            },
        },
        reportTypes: {
            get title(): string {
                return i18n.choose(
                    'Список типов отчетов, в которых будет использоваться колонка',
                    'Баған пайдаланылатын есеп түрлерінің тізімі',
                    'List of report types in which the column will be used',
                );
            },
            values: {
                get COMMON(): string {
                    return i18n.choose(
                        'обычный отчет',
                        'тұрақты есеп',
                        'common report',
                    );
                },
                get DETAILED(): string {
                    return i18n.choose(
                        'расширенный отчет',
                        'кеңейтілген есеп',
                        'detailed report',
                    );
                },
                get DEBUG(): string {
                    return i18n.choose(
                        'отладка',
                        'отладка',
                        'debugging',
                    );
                },
                get FZP_TOTAL(): string {
                    return i18n.choose(
                        'ФЗП - Всего',
                        'ФЗП - Барлығы',
                        'FZP - Total',
                    );
                },
                get FZP_CALC(): string {
                    return i18n.choose(
                        'ФЗП - Расчетные',
                        'ФЗП - Есеп айырысу',
                        'FZP - Calculated',
                    );
                },
                get FZP_NA(): string {
                    return i18n.choose(
                        'ФЗП - Новоприбывшие',
                        'ФЗП - Жаңадан келгендер',
                        'FZP - New arrivals',
                    );
                },
            },
        },
    },
    filterSort: {
        get title(): string {
            return i18n.choose(
                'Фильтры, сортировка',
                'Сүзгілер, сұрыптау',
                'Filter, sort',
            );
        },
        filter: {
            get copyToMax(): string {
                return i18n.choose(
                    'Скопировать как максимальное значение',
                    'Максималды мән ретінде көшіріңіз',
                    'Copy as maximal value',
                );
            },
            get maxValue(): string {
                return i18n.choose(
                    'Максимальное значение',
                    'Максималды мән',
                    'Maximal value',
                );
            },
            get minValue(): string {
                return i18n.choose(
                    'Минимальное значение',
                    'Ең төменгі мән',
                    'Minimal value',
                );
            },
            get partOfValue(): string {
                return i18n.choose(
                    'Часть значения',
                    'Мағынаның бөлігі',
                    'Part of the value',
                );
            },
            get reset(): string {
                return i18n.choose(
                    'Сбросить фильтры',
                    'Сүзгілерді қалпына келтіру',
                    'Reset filters',
                );
            },
            get title(): string {
                return i18n.choose(
                    'Фильтры',
                    'Сүзгілер',
                    'Filters',
                );
            },
            get valueSet(): string {
                return i18n.choose(
                    'Набор значений',
                    'Мәндер жиыны',
                    'Value set',
                );
            },
            get valueSetByComma(): string {
                return i18n.choose(
                    'Набор значений, разделенных запятыми',
                    'Үтірмен бөлінген мәндер жинағы',
                    'Value set separated by commas',
                );
            },
        },
        sort: {
            get field(): string {
                return i18n.choose(
                    'Поле для сортировки',
                    'Сұрыптауға арналған өріс',
                    'Field for sorting',
                );
            },
            get reversedOrder(): string {
                return i18n.choose(
                    'Сортировать в обратном порядке',
                    'Кері ретпен сұрыптау',
                    'Sort in reverse order',
                );
            },
            get title(): string {
                return i18n.choose(
                    'Сортировка',
                    'Сұрыптау',
                    'Sort',
                );
            },
        },
    },
    messages: {
        dataDeleted(id: number): string {
            return i18n.choose(
                () => `Данные успешно удалены, ID = #${id}`,
                () => `Деректер сәтті жойылды, ID = #${id}`,
                () => `Data deleted successfully, ID = #${id}`,
            )();
        },
        dataSaved(id: number): string {
            return i18n.choose(
                () => `Данные успешно сохранены, ID = #${id}`,
                () => `Деректер сәтті сақталды, ID = #${id}`,
                () => `Data saved successfully, ID = #${id}`,
            )();
        },
    },
};

const newSearchConfig = (): DictStRepFormColGroupSearchConfig => {
    return {
        itemsPerPage: null,
        page: null,
        idSet: null,
        parentSet: null,
        formSet: null,
        nameKk: null,
        nameRu: null,
        orderNumberStartValue: null,
        orderNumberEndValue: null,
        sortField: null,
        reversedSort: null,
    };
};


@Component({
    components: {
        CollapsiblePane,
        NumberInput,
        Overlay,
        Pagination,
    },
})
export default class DictStRepFormColGroupListPage extends ComponentBase {
    constructor() {
        super('');
    }


    // region Lifecycle
    created() {
        // region Навигация по страницам
        this.$watch('page', () => {
            this.loadIfIdle();
        });
        this.$watch('itemsPerPage', () => {
            this.loadIfIdle();
        });
        // endregion
    }

    protected mounted() {
        this.loadIfIdle();
    }
    // endregion


    // region Util
    // noinspection JSUnusedLocalSymbols
    private translates = translates;

    private formatDate(value: Date | null): string | null {
        if (value === null) {
            return null;
        }
        return i18nDb.translateByTemplate(i18nDb.dateTemplateLong(), value);
    }

    private get fieldOptions(): Array<Comp.DropdownItemDef<SortField | null>> {
        return [
            // Не заполнено
            {
                value: null,
                text: 'Не заполнено',
            },

            // ID
            {
                value: 'ID',
                text: translates.fields.id.title,
            },

            // PARENT
            {
                value: 'PARENT',
                text: translates.fields.parent.title,
            },

            // FORM
            {
                value: 'FORM',
                text: translates.fields.form.title,
            },

            // NAME_KK
            {
                value: 'NAME_KK',
                text: translates.fields.nameKk.title,
            },

            // NAME_RU
            {
                value: 'NAME_RU',
                text: translates.fields.nameRu.title,
            },

            // ORDER_NUMBER
            {
                value: 'ORDER_NUMBER',
                text: translates.fields.orderNumber.title,
            },

            // HIDDABLE_CELL
            {
                value: 'HIDDABLE_CELL',
                text: translates.fields.hiddableCell.title,
            },
        ];
    }
    // endregion


    // region Навигация по страницам
    private page = 0;
    private itemsPerPage = 25;
    private totalItems = 0;

    private onItemsPerPageChanged(itemsPerPage: unknown): void {
        this.itemsPerPage = (itemsPerPage as number);
    }
    // endregion


    // region Загрузка, общее
    private loading = false;
    private loadingId: symbol | null = null;
    // endregion


    // region Элементы, фильтрация, сортировка
    // noinspection JSMismatchedCollectionQueryUpdate
    private items: Array<Dict.StRepFormColGroup> = [];

    private filterSortModalVisible = false;
    private filterSortFilterPaneExpanded = false;
    private filterSortSortPaneExpanded = false;

    private filterIdSet: Set<number> = new Set();
    private filterIdSetInput: string = '';
    private filterParentSet: Set<number | null> = new Set();
    private filterParentSetInput: string = '';
    private filterFormSet: Set<string> = new Set();
    private filterFormSetInput: string = '';
    private filterNameKk: string = '';
    private filterNameKkInput: string = '';
    private filterNameRu: string = '';
    private filterNameRuInput: string = '';
    private filterOrderNumberStartValue: number | null = null;
    private filterOrderNumberStartValueInput: number | null = null;
    private filterOrderNumberEndValue: number | null = null;
    private filterOrderNumberEndValueInput: number | null = null;

    private sortField: SortField | null = 'ID';
    private tmpSortField: SortField | null = null;
    private reversedSort = false;
    private tmpReversedSort = false;

    private get filterIdSetParsed(): Array<number> {
        return this.filterIdSetInput
            .split(',')
            .map(value => parseInt(value.trim(), 10))
            .filter(value => (!isNaN(value)));
    }

    private get filterParentSetParsed(): Array<number | null> {
        return this.filterParentSetInput
            .split(',')
            .map(value => {
                const trimmed = value.trim();
                if (trimmed.toLowerCase() == 'null') {
                    return null;
                } else {
                    return parseInt(value.trim(), 10);
                }
            })
            .filter(value => (value == null) || (!isNaN(value)));
    }

    private get filterFormSetParsed(): Array<string> {
        return this.filterFormSetInput
            .split(',')
            .map(value => value.trim())
            .filter(value => (value.length > 0));
    }


    private changeFilterSort() {
        this.filterIdSetInput = [...this.filterIdSet].join(', ');
        this.filterParentSetInput = [...this.filterParentSet].join(', ');
        this.filterFormSetInput = [...this.filterFormSet].join(', ');
        this.filterNameKkInput = this.filterNameKk;
        this.filterNameRuInput = this.filterNameRu;
        this.filterOrderNumberStartValueInput = this.filterOrderNumberStartValue;
        this.filterOrderNumberEndValueInput = this.filterOrderNumberEndValue;

        this.tmpSortField = this.sortField;
        this.tmpReversedSort = this.reversedSort;
        this.filterSortModalVisible = true;
    }

    private resetFilter() {
        this.filterIdSetInput = '';
        this.filterParentSetInput = '';
        this.filterFormSetInput = '';
        this.filterNameKkInput = '';
        this.filterNameRuInput = '';
        this.filterOrderNumberStartValueInput = null;
        this.filterOrderNumberEndValueInput = null;
    }

    private applyFilterSort() {
        this.filterIdSet = new Set(this.filterIdSetParsed);
        this.filterParentSet = new Set(this.filterParentSetParsed);
        this.filterFormSet = new Set(this.filterFormSetParsed);
        this.filterNameKk = this.filterNameKkInput;
        this.filterNameRu = this.filterNameRuInput;
        this.filterOrderNumberStartValue = this.filterOrderNumberStartValueInput;
        this.filterOrderNumberEndValue = this.filterOrderNumberEndValueInput;

        this.sortField = this.tmpSortField;
        this.reversedSort = this.tmpReversedSort;
        this.loadIfIdle();
    }

    private loadIfIdle() {
        if (!this.loading) {
            this.load();
        }
    }

    private load() {
        if (this.loading) {
            console.error('Cannot load data - loading already in progress');
            return;
        }

        const searchConfig = newSearchConfig();
        searchConfig.itemsPerPage = this.itemsPerPage;
        searchConfig.page = this.page;
        searchConfig.sortField = this.sortField;
        searchConfig.reversedSort = this.reversedSort;

        if (this.filterIdSet.size > 0) {
            searchConfig.idSet = [...this.filterIdSet];
        }
        if (this.filterParentSet.size > 0) {
            searchConfig.parentSet = [...this.filterParentSet];
        }
        if (this.filterFormSet.size > 0) {
            searchConfig.formSet = [...this.filterFormSet];
        }
        if (this.filterNameKk.trim().length > 0) {
            searchConfig.nameKk = this.filterNameKk.trim();
        }
        if (this.filterNameRu.trim().length > 0) {
            searchConfig.nameRu = this.filterNameRu.trim();
        }
        if (this.filterOrderNumberStartValue != null) {
            searchConfig.orderNumberStartValue = this.filterOrderNumberStartValue;
        }
        if (this.filterOrderNumberEndValue != null) {
            searchConfig.orderNumberEndValue = this.filterOrderNumberEndValue;
        }

        const loadingId = Symbol('DictStRepFormColGroupListPage.load');
        this.loading = true;
        this.loadingId = loadingId;
        this.items = [];

        this.request<Utils.PaginationList<Dict.StRepFormColGroup>>(
            {
                url: '/api/budget/staffing_table/dict/dict_st_rep_form_col_group/list',
                method: 'POST',
                data: searchConfig,
            },
            (data) => {
                if (this.loadingId !== loadingId) {
                    return;
                }

                this.totalItems = data.itemCount;
                this.page = data.page;
                this.items = data.items;
            },
            () => this.translates.errors.cannotLoadData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }

                this.loadingId = null;
                this.loading = false;
            },
        );
    }


    private getReportTypesText(row: Dict.StRepFormCol): string {
        let result = '';

        row.reportTypes.forEach((reportType) => {
            let itemText: string;
            switch (reportType) {
                case 'COMMON':
                    itemText = this.translates.fields.reportTypes.values.COMMON;
                    break;
                case 'DETAILED':
                    itemText = this.translates.fields.reportTypes.values.DETAILED;
                    break;
                case 'DEBUG':
                    itemText = this.translates.fields.reportTypes.values.DEBUG;
                    break;
                case 'FZP_TOTAL':
                    itemText = this.translates.fields.reportTypes.values.FZP_TOTAL;
                    break;
                case 'FZP_CALC':
                    itemText = this.translates.fields.reportTypes.values.FZP_CALC;
                    break;
                case 'FZP_NA':
                    itemText = this.translates.fields.reportTypes.values.FZP_NA;
                    break;
                default:
                    itemText = reportType ?? '';
                    break;
            }

            if (result.length > 0) {
                result += ', ';
            }
            result += itemText;
        });

        return result;
    }
    // endregion


    // region Редактируемый элемент
    private elementChangeModalVisible = false;

    /**
     * ID
     *
     * `PRIMARY KEY`
     */
    private changedElementId: number | null = null;

    /**
     * ID родительской группы колонок
     */
    private changedElementParent: number | null = null;

    /**
     * Код формы в формате "XX-XXX", где "X" - цифра
     */
    private changedElementForm: string = '';

    /**
     * Название на казахском
     */
    private changedElementNameKk: string = '';

    /**
     * Название на русском
     */
    private changedElementNameRu: string = '';

    /**
     * Порядковый номер - для сортировки групп внутри одного родителя или групп верхнего уровня
     */
    private changedElementOrderNumber: number = 0;

    /**
     * Ячейка группы может быть скрыта при разных условиях
     */
    private changedElementHiddableCell: boolean = false;

    /**
     * Список типов отчетов, в которых будет использоваться колонка
     */
    private changedElementReportTypesCommon: boolean = false;

    /**
     * Список типов отчетов, в которых будет использоваться колонка - расширенный отчет
     */
    private changedElementReportTypesDetailed: boolean = false;

    /**
     * Список типов отчетов, в которых будет использоваться колонка - Отладка
     */
    private changedElementReportTypesDebug: boolean = false;

    /**
     * Список типов отчетов, в которых будет использоваться колонка - "ФЗП - Всего"
     */
    private changedElementReportTypesFzpTotal: boolean = false;

    /**
     * Список типов отчетов, в которых будет использоваться колонка - "ФЗП - Расчетные"
     */
    private changedElementReportTypesFzpCalc: boolean = false;

    /**
     * Список типов отчетов, в которых будет использоваться колонка - "ФЗП - Новоприбывшие"
     */
    private changedElementReportTypesFzpNa: boolean = false;


    private startElementChange(element?: Dict.StRepFormColGroup) {
        if (element === undefined) {
            this.changedElementId = null;
            this.changedElementParent = null;
            this.changedElementForm = '';
            this.changedElementNameKk = '';
            this.changedElementNameRu = '';
            this.changedElementOrderNumber = 0;
            this.changedElementHiddableCell = false;
            this.changedElementReportTypesCommon = false;
            this.changedElementReportTypesDetailed = false;
            this.changedElementReportTypesDebug = false;
            this.changedElementReportTypesFzpTotal = false;
            this.changedElementReportTypesFzpCalc = false;
            this.changedElementReportTypesFzpNa = false;
        } else {
            this.changedElementId = element.id;
            this.changedElementParent = element.parent;
            this.changedElementForm = element.form;
            this.changedElementNameKk = element.nameKk;
            this.changedElementNameRu = element.nameRu;
            this.changedElementOrderNumber = element.orderNumber;
            this.changedElementHiddableCell = element.hiddableCell ?? false;
            this.changedElementReportTypesCommon = element.reportTypes.includes('COMMON');
            this.changedElementReportTypesDetailed = element.reportTypes.includes('DETAILED');
            this.changedElementReportTypesDebug = element.reportTypes.includes('DEBUG');
            this.changedElementReportTypesFzpTotal = element.reportTypes.includes('FZP_TOTAL');
            this.changedElementReportTypesFzpCalc = element.reportTypes.includes('FZP_CALC');
            this.changedElementReportTypesFzpNa = element.reportTypes.includes('FZP_NA');
        }
        this.elementChangeModalVisible = true;
    }

    private saveElement(event: unknown) {
        (event as Event).preventDefault();

        if (this.loading) {
            console.error('Cannot save data - loading already in progress');
            return;
        }

        const reportTypes: Array<string> = [];
        if (this.changedElementReportTypesCommon) {
            reportTypes.push('COMMON');
        }
        if (this.changedElementReportTypesDetailed) {
            reportTypes.push('DETAILED');
        }
        if (this.changedElementReportTypesDebug) {
            reportTypes.push('DEBUG');
        }
        if (this.changedElementReportTypesFzpTotal) {
            reportTypes.push('FZP_TOTAL');
        }
        if (this.changedElementReportTypesFzpCalc) {
            reportTypes.push('FZP_CALC');
        }
        if (this.changedElementReportTypesFzpNa) {
            reportTypes.push('FZP_NA');
        }

        const data: Dict.StRepFormColGroup = {
            id: this.changedElementId,
            parent: this.changedElementParent,
            form: this.changedElementForm,
            nameKk: this.changedElementNameKk,
            nameRu: this.changedElementNameRu,
            orderNumber: this.changedElementOrderNumber,
            hiddableCell: this.changedElementHiddableCell,
            reportTypes: reportTypes,
        };


        const loadingId = Symbol('DictStRepFormColGroupListPage.saveElement');
        this.loading = true;
        this.loadingId = loadingId;

        this.request<number>(
            {
                url: '/api/budget/staffing_table/dict/dict_st_rep_form_col_group',
                method: 'POST',
                data,
            },
            (data) => {
                this.toast(
                    'success',
                    '',
                    this.translates.messages.dataSaved(data),
                );
                this.changedElementId = data;
            },
            () => this.translates.errors.cannotSaveData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }
                this.loadingId = null;
                this.loading = false;
                this.elementChangeModalVisible = false;
                this.load();
            }
        );
    }
    // endregion


    // region Удаление элемента
    private elementDeletionModalVisible = false;
    private removedElementId: number = 0;

    private startElementDeletion(element: Dict.StRepFormColGroup) {
        if (element.id === null) {
            console.error('Cannot delete element - ID is NULL');
            return;
        }

        this.removedElementId = (element.id as number);
        this.elementDeletionModalVisible = true;
    }

    private deleteElement(event: unknown) {
        (event as Event).preventDefault();

        if (this.loading) {
            console.error('Cannot delete element - loading already in progress');
            return;
        }

        const id = this.removedElementId;

        const loadingId = Symbol('DictStRepFormColGroupListPage.saveElement');
        this.loading = true;
        this.loadingId = loadingId;

        const url = this.prepareUrl(
            '/api/budget/staffing_table/dict/dict_st_rep_form_col_group',
            [
                ['id', id],
            ],
        );

        this.request<unknown>(
            {
                url,
                method: 'DELETE',
            },
            () => {
                this.toast(
                    'success',
                    '',
                    this.translates.messages.dataDeleted(id),
                );
            },
            () => this.translates.errors.cannotDeleteData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }
                this.loadingId = null;
                this.loading = false;
                this.elementDeletionModalVisible = false;
                this.load();
            }
        );
    }
    // endregion
}
